module.exports = __webpack_public_path__ + "static/fonts/MuseoSans_700.10aaa353.otf";